import c from "../../../utils/constants";

class userProfileCompletenessController {
  constructor(UsersService, NotificationService) {
    "ngInject"
   
    this.profileItemOptions = c.profileItems;
    this.usersService = UsersService;
    this.notificationService = NotificationService;
  }
 
  resetPayto() {
    if (!confirm('Are you sure you want to reset PayTo for this user?')) return;
    this.usersService.resetPayto(
      this.userId,
      () => this.notificationService.success('PayTo reset successful.'),
      () => this.notificationService.error('PayTo reset failed.')
    );
  }
  
  hasItem(item) {
    return this.profileItems & item;
  } 

  requiresGuardianApproval() {
    return this.providerInfo.requiresGuardianApproval || this.hasGuardian();
  }

  hasGuardian() {
    return this.providerInfo.guardians != null && this.providerInfo.guardians.length > 0;
  }

  hasApprovedGuardian() {
    if (!this.hasGuardian())
      return false;

    return this.providerInfo.guardians[0].status == 2;
  }
  
}

export default userProfileCompletenessController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-profile-completeness/user-profile-completeness.controller.js
 **/